var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tooltip-notification-container" },
    _vm._l(_vm.notificationItems, function (item) {
      return _c("NotificationItem", {
        key: item.id,
        attrs: { id: item.id, title: item.title, img: item.img },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }